import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const postCancelHelpRequest = async (payload) => {
  const { data } = await SigliveServiceSSE({ method: 'POST', url: `/productivity-host/cancel-help`, data: payload });

  return data?.data;
};

export default postCancelHelpRequest;
